import React, { Fragment } from 'react';
import { Grid, Box, Typography } from '@mui/material';
import {
    ClientLifeStageOptionPicker,
    DISCPicker,
    FreeTextArea
} from '../../../Inputs/Inputs';
import GPTProductCategoryCard from '../../../GPTProductRecommendationV2/GPTProductCategoryCard';
import ClientCard from './ClientCard';

export const ProductForm = ({
    intl,
    inputOptions,
    onValueChange,
    onTraitsChange,
    client,
    children
}) => {

    const product = inputOptions?.productName
        ? {
            productName: inputOptions.productName,
            productType: inputOptions.productType,
            coverageAmount: inputOptions.coverageAmount,
            coverageUnit: inputOptions.coverageUnit,
            chance: inputOptions.chance,
            reason: inputOptions.reason
        }
        : null;

    return (
        <Fragment>
            <Typography variant="body2">
                {intl.formatMessage({ id: 'chat-gpt-options-lazy-packs-product-desc' })}
            </Typography>

            {product && (
                <div style={{ marginTop: '12px', marginBottom: '12px' }}>
                    <GPTProductCategoryCard
                        product={product}
                        intl={intl}
                    />
                </div>
            )}
            {
                client && <ClientCard client={client} intl={intl}>
                    <ClientLifeStageOptionPicker
                        intl={intl}
                        options={inputOptions}
                        onValueChange={onValueChange}
                    />

                    <Grid>
                        <DISCPicker
                            intl={intl}
                            inputOptions={inputOptions}
                            onTraitsChange={onTraitsChange}
                        />
                    </Grid>


                    <FreeTextArea
                        intl={intl}
                        value={inputOptions?.freeText}
                        onChange={onValueChange}
                    />
                    {children}

                </ClientCard>
            }
        </Fragment>

    );
};

export default ProductForm;
